module.exports = __webpack_public_path__ + "img/分区04.7249e239.png";